module.exports = __webpack_public_path__ + "img/16.180d90e8.png";